import React from "react";
import { signUpSteps } from "../../authHelpers";
import Email from "./Email";
import RegistrationCode from "./RegistrationCode";
import MemberID from "./MemberID";
import Name from "./Name";
import Password from "./Password";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { Creators } from "@ReduxStore/actionTypes";
import { Member } from "@Src/constants";
import { Icon } from "@accessdev/arc-ui-react";
import { Trans } from "@lingui/react/macro";
import TermsAgreement from "./TermsAgreement";

import "./SignUpWizard.scss";

const { REGISTER_WITH_MEMBER_KEY, REGISTER_WITH_CODE } = Member;

function SignUpWizard(props) {
  const signUpStep = useSelector(selectors.getSignUpStep);
  const dispatch = useDispatch();

  const handleSignInClick = () => {
    dispatch(Creators.resetAuth());
  };

  const shouldRenderBackArrow =
    signUpStep !== signUpSteps.GENERAL && signUpStep !== signUpSteps.EMAIL && props.isPhone;

  const handleBackArrowClick = () => {
    const { registrationType } = props;
    switch (signUpStep) {
      case signUpSteps.REGISTRATION_CODE:
        dispatch(Creators.setSignUpStep(signUpSteps.EMAIL));
        break;
      case signUpSteps.MEMBER_ID:
        dispatch(Creators.setSignUpStep(signUpSteps.EMAIL));
        break;
      case signUpSteps.NAME:
        if (registrationType === REGISTER_WITH_MEMBER_KEY && !props.isCompleteProfile) {
          dispatch(Creators.setSignUpStep(signUpSteps.MEMBER_ID));
        } else if (registrationType === REGISTER_WITH_CODE && !props.isCompleteProfile) {
          dispatch(Creators.setSignUpStep(signUpSteps.REGISTRATION_CODE));
        } else {
          dispatch(Creators.setSignUpStep(signUpSteps.EMAIL));
        }
        break;
      case signUpSteps.PASSWORD:
        dispatch(Creators.setSignUpStep(signUpSteps.NAME));
        break;
      default:
        return;
    }
  };

  return (
    <div
      className={classNames("SignUpWizard", {
        initScreen: signUpStep === signUpSteps.GENERAL,
        isCompleteProfile: props.isCompleteProfile,
      })}
    >
      {shouldRenderBackArrow && (
        <div className="SignUpWizard-backScreen">
          <Icon
            icon="arrow_back"
            className="SignUpWizard-backScreen_icon"
            onClick={handleBackArrowClick}
            type="button"
            data-testid="back-arrow"
          />
        </div>
      )}
      {{
        [signUpSteps.REGISTRATION_CODE]: <RegistrationCode {...props} />,
        [signUpSteps.MEMBER_ID]: <MemberID {...props} />,
        [signUpSteps.NAME]: <Name {...props} />,
        [signUpSteps.PASSWORD]: <Password {...props} />,
        // Switch off the 'signUpStep' value
      }[signUpStep] || (
        // Email input is default
        <Email {...props} />
      )}

      {!props.isPhone && <TermsAgreement />}
      {!props.isCompleteProfile && (
        <div className="SignUpWizard-signInInstead t-title-small">
          <button className="SignUpWizard-signInLink t-title-med" onClick={handleSignInClick}>
            <Trans>Sign in</Trans>
          </button>
        </div>
      )}
    </div>
  );
}

export default SignUpWizard;
